import React, { useState, useCallback } from 'react';

import FileTypes from 'Constants/FileTypes';
import PropTypes from 'prop-types';

import FileDropzone from './Dropzone/FileDropzone';
import FilePreview from './Dropzone/FilePreview';
import { readFile } from './Dropzone/util';

const getExtension = (filename) => {
	if (filename.match(/.+(.xlsx)$/)) {
		return 'xlsx';
	} else {
		return 'html';
	}
};

// TODO: Accept multiple files
const FielderDropzone = ({ upload, acceptedTypes }) => {
	const [file, setFile] = useState(null);
	const [progress, setProgress] = useState(-1);
	const [error, setError] = useState(false);
	const [fileInfo, setFileInfo] = useState({
		name: '',
		type: '',
		extension: '',
		size: 0,
	});

	const uploadFile = (file) => {
		const { name, type, size } = file;

		let typeIsAccepted = acceptedTypes.some((acType) => {
			if (type === acType) return true;
		});

		if (typeIsAccepted) {
			setFileInfo({
				name: name,
				type: type,
				extension: getExtension(name),
				size: size,
			});

			setProgress(0);
			readFile(file, setFile, updateProgress);
		} else {
			setFileInfo({
				name: name,
				type: FileTypes.ERROR_TYPE,
				extension: '',
				size: 0,
			});
		}
	};

	const removeFile = useCallback(() => {
		setFileInfo({
			name: '',
			type: '',
			extension: '',
			size: 0,
		});
		setProgress(-1);
		setError(false);
		setFile(null);
	}, []);

	const updateProgress = (progressEvent) => {
		if (progressEvent.lengthComputable) {
			let percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
			setProgress(percent);
		}
	};

	const submitFile = () => {
		upload(file, fileInfo.extension);
		removeFile();
	};

	return (
		<>
			{fileInfo.name !== '' && (
				<FilePreview
					file={file}
					fileInfo={fileInfo}
					progress={progress}
					removeFile={removeFile}
					submitFile={submitFile}
					setError={setError}
				/>
			)}

			{file === null && error === false && <FileDropzone acceptedTypes={acceptedTypes} uploadFile={uploadFile} />}
		</>
	);
};

FielderDropzone.prototype = {
	acceptedTypes: PropTypes.array,
	uploadFile: PropTypes.func.isRequired,
};

FielderDropzone.defaultProps = {
	acceptedTypes: null,
};

export default FielderDropzone;
